import React from 'react';
import { ButtonProps } from './Button';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { tA11y } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import IconButton from './IconButton';

const CloseButton: React.FC<ButtonProps> = (props) => {
  return (
    <IconButton
      icon={faTimes}
      size="large"
      aria-label={tA11y('buttons.closeButton')}
      {...props}
    ></IconButton>
  );
};

export default CloseButton;
